import { getNavigatorLanguage } from './get-navigator-language';

export function inferLanguageFromNavigator(): string {
  const navigatorLanguage = getNavigatorLanguage();
  return navigatorLanguage;
}
